var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section main-section--practice-areas"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-10px mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "pt-lg-28px"
  }, [_c('h2', {
    staticClass: "tit tit--lg tit--point white--text line-height-11"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lang === 'ko' ? '업무분야' : 'Practice <br />Areas')
    }
  }), _c('span', {
    staticClass: "ko tit--point__circle",
    attrs: {
      "data-aos": "zoom-in"
    }
  })])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('v-row', {
    staticClass: "link-cards row--lg"
  }, _vm._l(_vm.currentItems, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('main-link-card', {
      attrs: {
        "to": item.to,
        "tit": item.title,
        "icon": item.icon,
        "data-aos": "fade-up",
        "data-aos-delay": index * 100
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])], 1);
  }), 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }